<template>
  <!-- 앱: 앱 전용 상단 네비게이션 -->
  <div v-if="isApp" class="lg:flex flex-1">
    <appNavigator :page="pageName" />
    <EduRegisterPayPage/>
  </div>

  <!-- 웹: 공용 네비게이션 -->
  <template v-else>
    <Nav />
    <!-- Nav는 fixed 라서 높이만큼 본문을 내린다 -->
    <div style="padding-top: var(--nav-height, 80px)">
      <EduRegisterPayPage/>
    </div>
  </template>
</template>

<script>
import Nav from "@/components/new/Nav.vue";
import EduRegisterPayPage from "@/pages/EduRegisterPayPage.vue";
import AppNavigator from "@/components/appNavigator.vue";

export default {
  name: "EduRegisterConfirmView",
  components: {AppNavigator, Nav, EduRegisterPayPage},
  data() {
    return {
      pageName: this.$route.name
    }
  },
  computed: {
    isApp() {
      return this.pageName === "eduRegisterConfirmApp";
    },
  },
}
</script>

<style scoped>

</style>
